var Handlebars = require("../../../../../node_modules/.pnpm/handlebars@4.7.10/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"filter-actions\">\n    <button class=\"action-submit\" type=\"submit\">\n        <i class=\"fa fa-check\"></i>\n    </button>\n    <button class=\"btn btn-link action-cancel\">\n        <i class=\"fa fa-times\"></i>\n    </button>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/scripts/core/templates/templates/filter-actions.hbs
// module id = yexj
// module chunks = 1